import { useCallback, useEffect, useState } from "react";
import { auth } from "./lib/api";
import type { Tab } from "./components/TopBar";
import { Login } from "./panels/Login";
import { Pillars } from "./panels/Pillars";
import { Terminal } from "./panels/Terminal";

/**
 * Auth gate. Three states, and the distinction matters: while we do not yet KNOW
 * whether there is a session, we must render neither the login (which would flash for
 * an authenticated user on every reload) nor the terminal (which would flash private
 * chrome at a logged-out one).
 */
export function App() {
  const [user, setUser] = useState<string | null | undefined>(undefined);
  const [tab, setTab] = useState<Tab>("rank");
  const [seenPillars, setSeenPillars] = useState(false);
  const openTab = useCallback((t: Tab) => {
    if (t === "pillars") setSeenPillars(true);
    setTab(t);
  }, []);

  useEffect(() => {
    auth.me().then((r) => setUser(r?.user ?? null));
  }, []);

  const onLogout = useCallback(async () => {
    await auth.logout();
    setUser(null);
  }, []);

  if (user === undefined) {
    return (
      <div className="h-full grid place-items-center text-term-dim">
        <div className="animate-pulse">srank</div>
      </div>
    );
  }
  if (!user) return <Login onAuthed={(u) => setUser(u)} />;
  // Two tabs that share nothing but the header: Rank is the served buy list and
  // factor browser; Pillars is the weighting workbench. Both stay mounted once
  // opened, so switching back does not throw away a ranking, a backtest or a scan —
  // but Pillars is not mounted (and fetches nothing) until it is first opened.
  return (
    <>
      <div className={tab === "rank" ? "h-full" : "hidden"}>
        <Terminal user={user} onLogout={onLogout} tab={tab} onTab={openTab} />
      </div>
      {seenPillars && (
        <div className={tab === "pillars" ? "h-full" : "hidden"}>
          <Pillars user={user} onLogout={onLogout} tab={tab} onTab={openTab} />
        </div>
      )}
    </>
  );
}
